import * as React from 'react'
import { StaticImage } from "gatsby-plugin-image"
import { SRLWrapper } from "simple-react-lightbox"

type GalleryBlockProps = {
  className?: string,
}

function GalleryBlock({ className }: GalleryBlockProps) {
  return (
    <SRLWrapper>
      <div className={`flex flex-wrap ${className}`}>
        <div className="w-1/2 md:w-1/5">
          <StaticImage src="../../images/gallery/gallery-01.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5">
          <StaticImage src="../../images/gallery/gallery-02.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5">
          <StaticImage src="../../images/gallery/gallery-03.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5">
          <StaticImage src="../../images/gallery/gallery-04.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5">
          <StaticImage src="../../images/gallery/gallery-05.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5 hidden md:block">
          <StaticImage src="../../images/gallery/gallery-06.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5 hidden md:block">
          <StaticImage src="../../images/gallery/gallery-07.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5 hidden md:block">
          <StaticImage src="../../images/gallery/gallery-08.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5 hidden md:block">
          <StaticImage src="../../images/gallery/gallery-09.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
        <div className="w-1/2 md:w-1/5 hidden md:block">
          <StaticImage src="../../images/gallery/gallery-10.jpg" alt="Salt Building Group project" aspectRatio={1} layout="constrained" placeholder="blurred" />
        </div>
      </div>
    </SRLWrapper>
  )
}

export default GalleryBlock;
